import { useEffect, useRef } from "react";
import "./App.css";
import About from "./Components/Content/About";
import Firstcard from "./Components/Content/Firstcard";
import Projects from "./Components/Content/Projects";
import Skills from "./Components/Content/Skills";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";

function App() {
  let myRef = useRef();
 
  
  return (
    <div className="App" >
      <Header />
      <Firstcard />
      <About />
      <Projects />
      <Skills />
      <Footer />
    </div>
  );
}

export default App;
